export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/pc-500w-c0e5ff530326b195d4b20390a50bbe28.webp";